import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createErrorFromResponse } from 'core/Error';
import { useModal } from 'store/modal';
import API from 'core/Api';

interface Props {
  id: number;
}

interface Leave {
  type: string;
  sub_type: string | null;
  date_from: string;
  date_to: string;
  leave_days: string;
  status: string;
}

const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}.${month}.${year}`;
};

const UpcomingLeaves: React.FC<Props> = ({ id }) => {
  const [upcomingLeaves, setUpcomingLeaves] = useState<Leave[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const { showModal } = useModal();
  const { t } = useTranslation();

  useEffect(() => {
    const fetchLeaves = async () => {
      try {
        const response = await API.get(`/users?id=${id}`);
        const user = response.data.items.find((item: any) => item.id === id);
        if (user) {
          setUpcomingLeaves(user.upcoming_leaves);
        }
      } catch (error) {
        showModal({
          type: 'error',
          content: createErrorFromResponse(error).message,
        });
      } finally {
        setIsLoading(false);
      }
    };
    fetchLeaves();
  }, [id]);

  if (isLoading || !upcomingLeaves) return null;

  return (
    <div>
      <h3 className="h5 mb-4 mt-2">{t('leaves.upcomingTitle')}</h3>
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            <th>{t('leaves.dateFrom')}</th>
            <th>{t('leaves.dateTo')}</th>
            <th>{t('leaves.type')}</th>
          </tr>
        </thead>
        <tbody>
          {upcomingLeaves.map((leave, index) => (
            <tr key={index}>
              <td>
                {formatDate(leave.date_from)}
                {t('leaves.yearShort')}
              </td>
              <td>
                {formatDate(leave.date_to)}
                {t('leaves.yearShort')}
              </td>
              <td>{t(`leaves.${leave.type}`)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UpcomingLeaves;
